module.exports = __webpack_public_path__ + "img/goto.d98ee81b.svg";